import React, { useRef, useState, MouseEvent, TouchEvent } from 'react';
import styles from './review.module.sass';
import { useTranslation } from 'react-i18next';

export default function Review() {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);
  const [offsetX, setOffsetX] = useState(0);
  const wrapperRef = useRef(null);

  const handleMouseDown = (e: MouseEvent) => {
    setIsDragging(true);
    setDragStartX(e.clientX - offsetX);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (isDragging) {
      const newOffsetX = e.clientX - dragStartX;
      setOffsetX(newOffsetX);
    }
  };

  const handleTouchStart = (e: TouchEvent) => {
    setIsDragging(true);
    setDragStartX(e.touches[0].clientX - offsetX);
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (isDragging) {
      const newOffsetX = e.touches[0].clientX - dragStartX;
      setOffsetX(newOffsetX);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className={styles.review__wrapper}>
      <div className={styles.review__header}>
        <span>{t('usersReview.whatOurClientsSay')}</span>
      </div>
      <div
        className={styles.review__containeer}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        ref={wrapperRef}
        style={{ transform: `translateX(${offsetX}px)` }}
      >
        <div className={styles.review__block}>
          <span className={styles.review__block_header}>
            {t('usersReview.arseniyP')}
          </span>
          <span className={styles.review__block_position}>
            {t('usersReview.psychiatristPrivatePractice')}
          </span>
          <span className={styles.review__block_text}>
            {t('usersReview.arseniyReview')}
          </span>
        </div>
        <div className={styles.review__block}>
          <span className={styles.review__block_header}>
            {t('usersReview.nataliaB')}
          </span>
          <span className={styles.review__block_position}>
            {t('usersReview.businessOwner')}
          </span>
          <span className={styles.review__block_text}>
            {t('usersReview.nataliaReview')}
          </span>
        </div>
        <div className={styles.review__block}>
          <span className={styles.review__block_header}>
            {t('usersReview.vladimirB')}
          </span>
          <span className={styles.review__block_position}>
            {t('usersReview.pizzeriaOwner')}
          </span>
          <span className={styles.review__block_text}>
            {t('usersReview.vladimirReview')}
          </span>
        </div>
        <div className={styles.review__block}>
          <span className={styles.review__block_header}>
            {t('usersReview.irinaV')}
          </span>
          <span className={styles.review__block_position}>
            {t('usersReview.masterManicurist')}
          </span>
          <span className={styles.review__block_text}>
            {t('usersReview.irinaReview')}
          </span>
        </div>
        <div className={styles.review__block}>
          <span className={styles.review__block_header}>
            {t('usersReview.antonP')}
          </span>
          <span className={styles.review__block_position}>
            {t('usersReview.holidayOrganizer')}
          </span>
          <span className={styles.review__block_text}>
            {t('usersReview.holidayReview')}
          </span>
        </div>
      </div>
    </div>
  );
}
